import React from 'react';
import { SHELL_WHITE, IRIS_PURPLE, LIVING_CORAL, alpha } from '../../../theme/colors';
import { HEALTH_MODES } from './healthProfileModes';

// Desktop-only: navy glass card (vs. mobile's glass-directly-on-photo
// treatment — see HealthProfileChips.js — chosen so the photo keeps
// carrying the visual weight on the smaller Feature card). An opaque
// white-card version was explored and rejected in favor of this.
// Sized noticeably smaller than the 1:1 Paper spec — at Paper's exact
// dimensions this card's bottom padding got clipped by the Feature card's
// fixed 644x580 frame. Diverging from Paper here on purpose.
const HealthProfileCard = () => (
  <div
    style={{
      width: 380,
      maxWidth: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 24,
      borderRadius: 16,
      backgroundColor: alpha('navy', 0.7),
      border: `1px solid ${alpha('white', 0.8)}`,
      boxShadow: `0 14px 34px ${alpha('navy', 0.22)}`,
    }}
  >
    <span style={{ fontFamily: 'Instrument Serif', fontStyle: 'italic', fontSize: 16, lineHeight: '24px', color: SHELL_WHITE }}>
      Your Health Profile
    </span>
    <span style={{ width: '100%', textAlign: 'center', fontFamily: 'DM Sans', fontSize: 10, lineHeight: 1.5, color: SHELL_WHITE, opacity: 0.85, marginTop: 6 }}>
      Activate different modes to reshape Vesna around your body.
    </span>

    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 6, marginTop: 12 }}>
      {HEALTH_MODES.map(({ label, Icon, active }) => (
        <div
          key={label}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            padding: '7px 11px',
            borderRadius: 999,
            background: active ? `linear-gradient(135deg, ${IRIS_PURPLE}, ${LIVING_CORAL})` : alpha('white', 0.7),
            border: active ? 'none' : `1.5px solid ${alpha('navy', 0.14)}`,
            boxShadow: active ? `0 4px 14px ${alpha('purple', 0.35)}` : 'none',
          }}
        >
          <Icon size={13} color={active ? SHELL_WHITE : alpha('navy', 0.55)} strokeWidth={2} />
          <span style={{ fontFamily: 'DM Sans', fontSize: 12, fontWeight: active ? 600 : 500, color: active ? SHELL_WHITE : alpha('navy', 0.7) }}>
            {label}
          </span>
        </div>
      ))}
    </div>
  </div>
);

export default HealthProfileCard;
